import axiosPrivate from "@services/axiosPrivate";
import { CREATE_PRICE_URL } from "src/constants";

export const createPrice = (price) => {
    return axiosPrivate.post(`${CREATE_PRICE_URL}`, price);
}